$(document).ready(function () {
  /* COUNDOWN SECTION */
  if ($(".coundown-section").length) {
    /* COUNDOWN */
    (function () {
      const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;

      //I'm adding this section so I don't have to keep updating this pen every year :-)
      //remove this if you don't need it
      // let today = new Date(),
      //   dd = String(today.getDate()).padStart(2, "0"),
      //   mm = String(today.getMonth() + 1).padStart(2, "0"),
      //   yyyy = today.getFullYear(),
      //   nextYear = yyyy + 1,
      //   dayMonth = "2/18/",
      //   targeted_day = $("#countdown").attr("data-target-day"),
      //   targeted_month = $("#countdown").attr("data-target-month"),
      //   target_date = dayMonth + yyyy;

      // today = mm + "/" + dd + "/" + yyyy;
      // if (today > target_date) {
      //   target_date = dayMonth + nextYear;
      // }
      // //end

      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear();
      let nextYear = yyyy + 1;

      let targeted_day = $("#countdown").attr("data-target-day");
      let targeted_month = $("#countdown").attr("data-target-month");

      // Format target date
      let target_date = new Date(yyyy, targeted_month - 1, targeted_day);
      let todayDate = new Date(yyyy, today.getMonth(), today.getDate());

      // If target_date is already passed, set it for next year
      if (todayDate > target_date) {
        target_date = new Date(nextYear, targeted_month - 1, targeted_day);
      }

      console.log("Next target_date:", target_date.toDateString());

      // Now you can use `target_date` for further calculations
      console.log("Next target_date date:", target_date);

      const countDown = new Date(target_date).getTime(),
        x = setInterval(function () {
          const now = new Date().getTime(),
            distance = countDown - now;

          (document.getElementById("days").innerText = Math.floor(
            distance / day
          )),
            (document.getElementById("hours").innerText = Math.floor(
              (distance % day) / hour
            )),
            (document.getElementById("minutes").innerText = Math.floor(
              (distance % hour) / minute
            )),
            (document.getElementById("seconds").innerText = Math.floor(
              (distance % minute) / second
            ));

          //do something later when date is reached
          if (distance < 0) {
            document.getElementById("headline").innerText =
              "target_date triggered!";
            document.getElementById("countdown").style.display = "none";
            document.getElementById("content").style.display = "block";
            clearInterval(x);
          }
          //seconds
        }, 0);
    })();
  }

  /* WATCH DETAILS SECTION */
  if($(window).width() > 989) {
      if ($(".watch-details-section").length > 0) {
        $(".details-box .box").on("click", function () {
          if (!$(this).hasClass("active")) {
            var itemID = $(this).closest(".box").attr("data-id");
            if (!$("#" + itemID).is(":visible")) {
              $(".image-column").hide();
              $("#" + itemID).fadeIn();
            }
            $(this).addClass("active").siblings(".box").removeClass("active");
            
            $(".main-box").hide();
            $(this).find(".main-box").slideDown();            
          }
        });
      }
    } else {
      if ($(".watch-details-section").length > 0) {
      $(".details-box .box").on("click", function () {
        if (!$(this).hasClass("active")) {
          var itemID = $(this).closest(".box").attr("data-id");
          if (!$("#" + itemID).is(":visible")) {
            $(".image-column").hide();
            $("#" + itemID).fadeIn();
          }
          $(this).addClass("active").siblings(".box").removeClass("active");
          
          $(".main-box").slideUp();
          $(this).find(".main-box").slideDown();
          
        } else {
          $(this).removeClass("active");
          $(this).find(".main-box").slideUp();
        }
      });
    }
    
    }

  /* FAQ SECTION */
  if ($(".faq-section").length > 0) {
    $(".faq-box .faq-content").hide();
    $(".faq-box:first .faq-content").show();
    $(".faq-box:first .faq-title").toggleClass("active");

    $(".faq-title").click(function () {
      $(".faq-title").not($(this)).removeClass("active");
      $(".faq-content").not($(this).next()).slideUp();
      $(this).toggleClass("active");
      $(this).next().slideToggle(250);
    });
  }

  $('.slider').slick({
  infinite: true,
	dots: true,
	arrows: false,
	autoplay: true,
	autoplaySpeed: 3000,
	fade: true,
	fadeSpeed: 1000
});

   $(".trigger-contact-popup").on("click", function (e) {
     e.preventDefault();
    $(".contact-popup").removeClass("hide_it");
                  $("body").addClass("contact-popup-overlay");
  });


      $(".contact-popup .close-button").on("click", function (e) {
        e.preventDefault();
        $(".contact-popup").addClass("hide_it");
        $("body").removeClass("contact-popup-overlay");
        // $('.contact-popup .form_fields_wrapper').removeClass("hide_it");
      });

//   window.addEventListener('DOMContentLoaded', ()=> {

// 	if ( window.pageYOffset > 0 ) {
// 		let header = $('.shopify-section.section-header');
// 		header.classList.add('scrolled-past-header shopify-section-header-sticky animate');
// 	}

// });

    if ($(window).scrollTop() > 0) {
        let header = $('.shopify-section.section-header');
        header.addClass('scrolled-past-header shopify-section-header-sticky');
    }


if (window.location.search.includes("contact_posted=true") && window.location.hash === "#Popup-ContactForm") {
        $(".contact-popup").removeClass("hide_it");
        $("body").addClass("contact-popup-overlay");
        $('.contact-popup .form_fields_wrapper').addClass("hide_it");

        // Remove the query parameter and hash from the URL
        const newUrl = window.location.pathname; // Keeps the current page URL without parameters
        history.replaceState(null, "", newUrl);
    }


    if (window.location.search.includes("customer_posted=true") && window.location.hash === "#contact_form") {
        // Remove the query parameter and hash from the URL
        const newUrl = window.location.pathname; // Keeps the current page URL without parameters
        history.replaceState(null, "", newUrl);
    }

  
    $('button.downloadImage').on('click', function(event) {
    event.preventDefault();
    
    // Get the URL from the data-img-src attribute
    const url = $(this).data('img-src');
    console.log('Original Image URL:', url);

    // Remove query string from URL
    const cleanUrl = removeQueryString(url);
    console.log('Clean Image URL:', cleanUrl);

    downloadImage(cleanUrl);
  });

  function removeQueryString(url) {
    const urlObject = new URL(url, window.location.origin); // Handle relative URLs
    urlObject.search = ''; // Remove query string
    return urlObject.toString();
  }

  function downloadImage(url) {
    const filename = url.split('/').pop();

    fetch(url, {
      mode: 'no-cors',
    })
      .then(response => response.blob())
      .then(blob => {
        let blobUrl = window.URL.createObjectURL(blob);
        let a = $('<a></a>');
        a.attr('download', filename); // Use clean filename
        a.attr('href', blobUrl);
        $('body').append(a);
        a[0].click();
        a.remove();
      });
  }
  
});

